// --------------------- Import Globais ---------------------
import { useEffect, useRef, useState } from "react";
// --------------------- Import Antd-Design ---------------------
import { Modal } from "antd";
import { useNavigate } from "react-router-dom";
// --------------------- Import Hooks ---------------------
import { useAtualizarPostagem } from "../hooks/useAtualizarPostagem";
// --------------------- Import Styles ---------------------
import { Title } from "../../ViewGerenciarPostagens/styles";
// --------------------- Import Uteis ---------------------
import { useError } from "../../../uteis/mensagens/useError";
import { useSuccess } from "../../../uteis/mensagens/useSuccess";

export default function ModalExcluir({
  isModalOpen,
  handleFechar,
  postagemId,
}: any) {
  // Seta o dado que irá ser atualizado
  const postagemData = {
    active: 0,
  };
  // Chamada da função para atualizar
  const {
    atualizar,
    isLoading: isLoadingAtualizar,
    error,
    success,
  } = useAtualizarPostagem();

  const errorRef = useRef<boolean | null>(false);

  // Atualiza o valor de errorRef e warningRef toda vez que o error e warning mudar
  useEffect(() => {
    if (error) {
      errorRef.current = error;
    }
  }, [error]);

  // Exibe a Mensagem de  Erro
  const { showError, contextHolder: errorContextHolder } = useError();

  // Exibe a Mensagem de  Erro
  const { showSuccess, contextHolder: successContextHolder } = useSuccess();

  // Estado para controlar se o erro já foi exibido
  const [errorDisplayed, setErrorDisplayed] = useState(false);

  // Estado para controlar se o sucesso já foi exibido
  const [successDisplayed, setSuccessDisplayed] = useState(false);

  // Hook de navegação do React Router
  const navigate = useNavigate();
  useEffect(() => {
    if (isModalOpen && success && !successDisplayed) {
      // Mensagem de sucesso
      const msgSuccess = "Postagem excluida com sucesso!";
      showSuccess(msgSuccess);
      setSuccessDisplayed(true);

      // Limpa sucesso após 3 segundos
      setTimeout(() => {
        navigate(0);
      }, 2000);
    }

    if (isModalOpen && errorRef.current && !errorDisplayed) {
      // Mensagem de erro
      let msgError = "Não foi possível excluir a Postagem, tente novamente!";
      showError(msgError);
      setErrorDisplayed(true);

      // Limpa erro após 3 segundos
      setTimeout(() => {
        setErrorDisplayed(false);
        errorRef.current = null;
      }, 3000);
    }

    // Reset quando o modal fecha
    if (!isModalOpen) {
      setSuccessDisplayed(false);
      setErrorDisplayed(false);
    }
  }, [
    isModalOpen,
    success,
    error,
    showSuccess,
    showError,
    successDisplayed,
    errorDisplayed,
    navigate,
  ]);

  return (
    <>
      <Modal
        open={isModalOpen}
        onCancel={handleFechar}
        cancelText="Cancelar"
        okText="Excluir"
        onOk={() => atualizar(postagemId, postagemData)}
        confirmLoading={isLoadingAtualizar}
        okButtonProps={{
          style: {
            backgroundColor: "#003644",
            borderColor: "#003644",
            color: "white",
          }, // Botão "Ativar" com fundo verde
        }}
        cancelButtonProps={{
          style: {
            backgroundColor: "#f44336",
            borderColor: "#f44336",
            color: "white",
          }, // Botão "Cancelar" com fundo vermelho
        }}
      >
        {
          <>
            <>{errorContextHolder}</>
            <>{successContextHolder}</>
            <Title>Tem certeza que gostaria de excluir essa Postagem?</Title>
          </>
        }
      </Modal>
    </>
  );
}
